import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { closeAvailability } from 'app/actions/AvailabilityDetailActions';
import { AvailabilityDetailsContainer } from 'app/components/bibs/shared/AvailabilityDetails';
import { FullScreenOverlayContainer } from 'app/components/shared/FullScreenOverlay';

const AvailabilityDetailsOverlayAdapter = ({
  closeAvailability: closeAvailabilityAction,
  isHideCloseButton,
  isOpen,
  metadataId
}) => {
  if (!metadataId) {
    return null;
  }

  return (
    <FullScreenOverlayContainer
      dataKey="availability-details-adapter-full-screen-overlay"
      disableClose={isHideCloseButton}
      handleClose={closeAvailabilityAction}
      open={isOpen}
      overlayKey="availability-details-adapter-full-screen-overlay"
    >
      <AvailabilityDetailsContainer metadataId={metadataId} />
    </FullScreenOverlayContainer>
  );
};

AvailabilityDetailsOverlayAdapter.defaultProps = {
  isHideCloseButton: false
};

AvailabilityDetailsOverlayAdapter.propTypes = {
  closeAvailability: PropTypes.func.isRequired,
  isHideCloseButton: PropTypes.bool,
  isOpen: PropTypes.bool.isRequired,
  metadataId: PropTypes.string
};

function mapStateToProps(state) {
  const availabilityDetail = state.get('availabilityDetail');

  return {
    isOpen: availabilityDetail.get('open'),
    metadataId: availabilityDetail.get('metadataId')
  };
}

const mapDispatchToProps = {
  closeAvailability
};

export default connect(mapStateToProps, mapDispatchToProps)(AvailabilityDetailsOverlayAdapter);
